import React from 'react';
import './OrderVoucherSummary.scss';
import { Divider } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';

interface IProps {
  item: Julius.Website.OrderItemViewModel;
}

const OrderVoucher: React.SFC<IProps> = ({
  item: {
    name,
    count,
    price,
    totalPrice,
  },
}) => (
  <>
    <div className='order-voucher'>
      <div className='name-container'>
        <span className='sub-title medium-bold'>{ name }</span> á&nbsp;
        <PriceItem price={ price } decimals={ 2 } />&nbsp;
      </div>
      <div className='quantity-container'>
        <span>{ count }</span>
      </div>
      <div className='total-price-container'>
        <PriceItem style='price-item medium-bold' price={ totalPrice } decimals={ 2 } />
      </div>
    </div>
    <Divider />
  </>
);

export default OrderVoucher;


// WEBPACK FOOTER //
// ./src/components/OrderVoucherSummary/OrderVoucher.tsx